// extracted by mini-css-extract-plugin
export default {"Activate":"PlcUpgradeAbilities_Activate__dy4ob"};